import { forwardRef } from "react";
import { cn } from "@synthesis/shared-utils";
import { jsx } from "react/jsx-runtime";
//#region src/Tab/index.tsx
/**
* Компонент Tab
* Дизайн - https://www.figma.com/file/uRPlsieHFpRpRsYDX2KV1Q/%D0%90%D1%81%D1%83%D0%B1%D0%B8%D0%BC.-%D0%A0%D0%96%D0%94-UI-Kit?node-id=402%3A5694
*/
const Tab = forwardRef(({ active = false, title, truncate = true, className, ...rest }, ref) => {
	return /* @__PURE__ */ jsx("div", {
		ref,
		className: cn("relative cursor-pointer py-[0.625rem] font-sans text-base", truncate ? "max-w-[250px] truncate" : "shrink-0 whitespace-nowrap", active ? "text-brand-40 after:bg-brand-40 after:absolute after:bottom-0 after:left-0 after:h-1 after:w-full after:rounded-sm after:content-['']" : "text-type-light hover:text-labels-secondary focus:text-labels-secondary", className),
		...rest,
		children: title
	});
});
Tab.displayName = "Tab";
//#endregion
export { Tab };

//# sourceMappingURL=index.js.map